<template>
  <div>
    <div class="error-page">
      <h2 class="headline text-yellow"> 404</h2>

      <div class="error-content">
        <h3><i class="fa fa-warning text-yellow"></i> Oops! Page not found.</h3>

        <p>
          We could not find the page you were looking for.
          Meanwhile, you may return to 
          <router-link 
            :to="{name:'DashBoard'}"
          >dashboard</router-link>
           or 
          <router-link 
            :to="{name:'Login'}"
          >login page</router-link>
        </p>

        <!-- <form class="search-form">
          <div class="input-group">
            <input type="text" name="search" class="form-control" placeholder="Search">

            <div class="input-group-btn">
              <button type="submit" name="submit" class="btn btn-warning btn-flat"><i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </form> -->
      </div>
      <!-- /.error-content -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'PageNotFoundView',
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    
  },
  components: {
    
  },
  mounted() {
    let body = document.getElementsByTagName("BODY")[0];
    body.className = "login-page hold-transition";
  }
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/PageNotFound/PageNotFoundView.vue